import { createFeatureSelector } from '@ngrx/store';
import { State, configFeatureKey } from '../reducers/config.reducer';

export const selectConfig = createFeatureSelector<State>(configFeatureKey);
